import { SIZES } from 'app/app/(client)/utils/client-constants'
import { sizes } from 'app/types/types'
import React, { InputHTMLAttributes, Ref } from 'react'

type InputAtomProps = InputHTMLAttributes<HTMLInputElement> & {
  id: string
  name?: string
  type?: 'text' | 'password' | 'email' | 'number' | 'tel' | 'search' | 'date' | 'radio' | 'checkbox' | 'file' | 'url'
  className?: string
  value?: string
  inputSize?: sizes
  onChangeFn?: (e: React.ChangeEvent<HTMLInputElement>) => void
  onBlurFn?: (e: React.FocusEvent<HTMLInputElement>) => void
  disabled?: boolean
  inputRef?: Ref<HTMLInputElement>
}

const Input: React.FC<InputAtomProps> = ({
  id,
  name,
  type,
  className,
  value = '',
  inputSize = SIZES.medium,
  onChangeFn,
  disabled = false,
  onBlurFn,
  inputRef,
  ...props
}) => (
  <input
    id={id}
    name={name}
    type={type || 'text'}
    className={className + ' ' + inputSize}
    disabled={disabled}
    ref={inputRef}
    {...(onChangeFn ? { value, onChange: onChangeFn } : { defaultValue: value })}
    {...(onBlurFn ? { onBlur: onBlurFn } : {})}
    {...props}
  />
)

export default Input
